import { createAction } from "@coverme/redux";
import Axios from "axios";
import { cloneDeep, sortBy } from "lodash-es";
import { shouldContinueInterviewAtPiGate } from "../services/eligibilityService";
import { getEncounterTag } from "./tagsActions";
import { getCaseClues } from "./caseCluesActions";

export function updateInterviewStatus(section, status) {
    return {
        type: "UPDATE_INTERVIEW_STATUS",
        section: section,
        status: status,
    };
}

export const updateCoverageStatus = value => {
    return {
        type: "UPDATE_COVERAGE_STATUS",
        value: value,
    };
};

export const quickEntry = (customerId, data) =>
    createAction("QUICK_ENTRY", () => {
        return Axios.post("api/customer/" + customerId + "/encounter/quick_entry", data).then(result => {
            return result.data;
        });
    });

export const setInterviewError = section => updateInterviewStatus(section, "error");

export const setEntry = data =>
    createAction("UPDATE_ENTRY", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        const customerId = getState().customer?.data?.customer?.GlobalId;
        if (data.responsibleParty != null) {
        }

        if (encounterId == null || encounterId === "") {
            return createInterview(customerId, data);
        } else {
            return updateInterview(encounterId, data);
        }
    });
export const createEntryForOcrQuickEntry = (customerId, data) => createInterviewForOcrQuickEntry(customerId, data);

export const setCoverage = (data, encounterId = "") =>
    createAction("UPDATE_COVERAGE", (dispatch, getState) => {
        if (encounterId === null || encounterId === "") {
            encounterId = getState().interview.encounterId;
        }

        // TODO: coverage summary model does not match with server; this is breaking the the call and that is why is being removed from the request in the line below.
        // this is not a problem as coverageSummary is not persisted in the encounters_persons table
        // either this is okay OR the coverageSummary model needs to be fixed
        delete data.coverageSummary;
        return Axios.put(`api/encounter/${encounterId}/patient/coverage`, data).then(() => {
            dispatch(getEncounterTag(encounterId));
            return data;
        });
    });

export const triggerCoverageVerification = (
    companyName,
    memberNumber,
    includeNegatives = true,
    reprocessCoverage = true
) =>
    createAction("GET_COVERAGE_VERIFICATION", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        const externalId = getState().interview.entry.patient.personId;
        const customerId = getState().customer?.data?.customer?.GlobalId;

        const coveragePayload = {
            externalId: externalId,
            encounterId: encounterId,
            memberId: memberNumber,
            includeNegatives: includeNegatives,
            companyName: companyName,
            reprocessCoverage: reprocessCoverage,
        };

        return Axios.post("/api/customer/" + customerId + "/person/coverage/verification", coveragePayload)
            .then(res => {
                dispatch(updateCoverageStatus(true));
                dispatch(getCoverage(encounterId));
                dispatch(getIsFullyCovered(encounterId));
                dispatch(getEncounterTag(encounterId));
                return res.data;
            })
            .catch(err => {
                if (err.response.status == 429) {
                    return {
                        personCoverages: [],
                        error: {
                            title: err.response.statusText,
                            description: err.response.data,
                        },
                    };
                }
                return {
                    personCoverages: [],
                    error: {
                        title: "Coverage not available",
                        description: "Coverage cannot be confirmed",
                    },
                };
            });
    });

export const triggerCoverageDiscovery = (includeNegatives = false, reprocessCoverage = true) =>
    createAction("GET_COVERAGE_DISCOVERY", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        const externalId = getState().interview.entry.patient.personId;
        const memberId = getState().interview.coverage?.primaryCoverage?.memberNumber;
        const coverage = getState().interview.coverage;
        const customerId = getState().customer?.data?.customer?.GlobalId;

        const coveragePayload = {
            interviewCoverage: coverage,
            externalId: externalId,
            encounterId: encounterId,
            memberId: memberId,
            includeNegatives: includeNegatives,
            reprocessCoverage: reprocessCoverage,
        };

        return Axios.post("/api/customer/" + customerId + "/person/coverage/discovery", coveragePayload)
            .then(res => {
                dispatch(updateCoverageStatus(true));
                dispatch(getCoverage(encounterId));
                dispatch(getIsFullyCovered(encounterId));
                dispatch(getEncounterTag(encounterId));
                return res.data;
            })
            .catch(err => {
                if (err.response.status == 429) {
                    return {
                        personCoverages: [],
                        error: {
                            title: err.response.statusText,
                            description: err.response.data,
                        },
                    };
                }
                return {
                    personCoverages: [],
                    error: {
                        title: "Coverage not available",
                        description: "Coverage cannot be confirmed",
                    },
                };
            });
    });

export const getPreviouslyObtainedCoverage = (encounterId, customerId) => {
    return createAction("GET_COVERAGE_SUMMARY", (dispatch, getState) => {
        return Axios.get(`/api/customer/${customerId}/encounter/${encounterId}/coverage`)
            .then(res => {
                const encounterId = getState().interview.encounterId;
                dispatch(getIsFullyCovered(encounterId));
                return res.data;
            })
            .catch(err => {
                return {
                    error: "Coverage not available",
                };
            });
    });
};

export const setHouseholdMembers = householdMembers =>
    createAction("UPDATE_HOUSEHOLD_MEMBERS", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        const newlyAddedHouseholdMembers = householdMembers.map((x, i) => {
            if (x.personId == null || x.personId === "") {
                return createHouseholdMember(encounterId, x).then(data => {
                    return { index: i, data: data };
                });
            } else {
                return updateHouseholdMemberProxy(encounterId, x).then(data => {
                    return { index: i, data: x };
                });
            }
        });

        return Promise.all(newlyAddedHouseholdMembers).then(values => {
            const sortedItems = sortBy(values, x => x.index);
            return sortedItems.map(x => {
                return { ...x.data, tax: {} };
            });
        });
    });

export const addHouseholdMember = householdMember =>
    createAction("ADD_HOUSEHOLD_MEMBER", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        return createHouseholdMember(encounterId, householdMember);
    });

export const updateHouseholdMember = householdMember =>
    createAction("UPDATE_HOUSEHOLD_MEMBER", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        return updateHouseholdMemberProxy(encounterId, householdMember).then(data => householdMember);
    });

export const setPersonsScreeningInfo = data =>
    createAction("UPDATE_PERSONS_INFO_SCREENING", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        return Axios.put(`api/encounter/${encounterId}/persons/screening`, data).then(() => data);
    });

export const setAssets = assets =>
    createAction("UPDATE_ASSETS", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        return Axios.put(`api/encounter/${encounterId}/patient/assets`, assets).then(() => assets);
    });

export const setLiabilities = liabilities =>
    createAction("UPDATE_LIABILITIES", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        return Axios.put(`api/encounter/${encounterId}/patient/liabilities`, liabilities).then(() => liabilities);
    });

export const setExchange = exchange =>
    createAction("UPDATE_EXCHANGE", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        return Axios.put(`api/encounter/${encounterId}/patient/exchange`, exchange).then(() => exchange);
    });

export const setPatientGovernmentInfo = data =>
    createAction("UPDATE_GOVERNMENT", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        return Axios.put(`api/encounter/${encounterId}/patient/government`, data).then(() => {
            dispatch(
                setAssets({
                    hasAssets: data.hasAssets,
                    assets: data.assets,
                })
            );
            return data;
        });
    });

export const setPatientFinancialAssistanceInfo = data =>
    createAction("UPDATE_FINANCIAL_ASSISTANCE", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        return Axios.put(`api/encounter/${encounterId}/patient/financialAssistance`, data).then(() => {
            return data;
        });
    });

export const setSupplementalInfo = data =>
    createAction("UPDATE_SUPPLEMENTAL", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        const { hasAssets, assets, hasMajorMonthlyExpenses, expenses, hasMajorDebts, debts } = data;
        delete data.hasAssets;
        delete data.assets;
        delete data.hasMajorMonthlyExpenses;
        delete data.expenses;
        delete data.hasMajorDebts;
        delete data.debts;
        return Axios.put(`api/encounter/${encounterId}/patient/supplemental`, data).then(() => {
            if (hasAssets != null) {
                dispatch(
                    setAssets({
                        hasAssets: hasAssets,
                        assets: assets,
                    })
                );
            }

            if (hasMajorDebts != null || hasMajorMonthlyExpenses != null) {
                dispatch(
                    setLiabilities({
                        expenses: hasMajorMonthlyExpenses === true ? expenses : [],
                        debts: hasMajorDebts === true ? debts : [],
                    })
                );
            }
            return data;
        });
    });

function createInterview(customerId, data) {
    return Axios.post(`api/customer/${customerId}/encounter/`, data).then(result => {
        return result.data;
    });
}

function createInterviewForOcrQuickEntry(customerId, data) {
    return Axios.post(`api/customer/${customerId}/encounter/ocr_quick_entry`, data).then(result => {
        return result.data;
    });
}

function updateInterview(encounterId, data) {
    return Axios.put(`api/encounter/${encounterId}/entry`, data).then(result => {
        return result.data;
    });
}

export function getInterview(customerId, encounterId) {
    return createAction("GET_INTERVIEW", (dispatch, getState) => {
        return Axios.get(`api/customer/${customerId}/encounter/${encounterId}`).then(result => {
            dispatch(getPersonVerifications(encounterId));
            dispatch(getEncounterTag(encounterId));
            return result.data;
        });
    });
}

export const deleteHouseholdMember = personId =>
    createAction("DELETE_HOUSEHOLD_MEMBER", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        return Axios.delete(`/api/encounter/${encounterId}/person/${personId}/`).then(() => personId);
    });

export const setPatientInfoScreening = data =>
    createAction("UPDATE_PATIENT_INFO_SCREENING", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        const fplValues = getState().interviewLookups.data.federalPovertyLevel;
        const result = shouldContinueInterviewAtPiGate(data, fplValues);
        return Axios.put(`api/encounter/${encounterId}/patient/screening`, data).then(() => {
            return {
                ...data,
                shouldContinue: result,
            };
        });
    });

export const resetInterview = () => {
    return createAction("RESET_INTERVIEW");
};

export const updateEncounterStatus = (encounterId, status) =>
    createAction("UPDATE_ENCOUNTER_STATUS", (dispatch, getState) =>
        Axios.put(`/api/encounter/${encounterId}/status`, JSON.stringify(status)).then(data => {
            dispatch(getCaseClues(encounterId));
            return status;
        })
    );

export function cloneEncounter(encounterId) {
    return Axios.post(`/api/encounter/${encounterId}/clone`).then(data => data.data);
}

export function reopenEncounter(encounterId) {
    return Axios.post(`/api/encounter/${encounterId}/reopen`).then(data => data.data);
}

export function cloneEncounterIntoAnother(encounterId, destinationEncounterId) {
    return Axios.post(`/api/encounter/${encounterId}/clone/${destinationEncounterId}`).then(data => data.data);
}

function createHouseholdMember(encounterId, data) {
    return Axios.post(`api/encounter/${encounterId}/person/`, data).then(result => result.data);
}

function updateHouseholdMemberProxy(encounterId, data) {
    return Axios.put(`api/encounter/${encounterId}/person/${data.personId}`, data);
}

export const getIsFullyCovered = encounterId =>
    createAction("GET_IS_FULLY_COVERED", (dispatch, getState) =>
        Axios.get(`/api/encounter/${encounterId}/isfullycovered`).then(res => {
            dispatch(getEncounterTag(encounterId));
            return res.data;
        })
    );

export const setPersonCoverage = coverage =>
    createAction("SET_PERSON_COVERAGE", (dispatch, getState) => {
        // fix the person id
        // const personId = getState().person.data[getState().interview.entry.patient.personId].globalId;
        // coverage.personId = personId;
        // fix the globalId
        const globalId = getState().customer.data.customer.GlobalId;
        coverage[0].GlobalId = globalId;
        return Axios.post("/api/person/coverage", coverage).then(res => coverage);
    });

export const updatePersonCoverage = coverage =>
    createAction("UPDATE_PERSON_COVERAGE", (dispatch, getState) => {
        dispatch(getEncounterTag(coverage.encounterId));
        return Promise.resolve(coverage);
    });

export const deletePersonCoverage = coverage =>
    createAction("DELETE_PERSON_COVERAGE", () =>
        Axios.delete("/api/person/coverage", { data: coverage }).then(res => coverage)
    );

export const deleteManuallyProvidedCoverage = (customerId, criteria) =>
    createAction(`DELETE_MANUAL_PERSON_COVERAGE`, (dispatch, getState) => {
        Axios.delete(
            `/api/customer/${customerId}/encounter/${criteria.encounterId}/person/external/${criteria.personId}/coverage/manual/${criteria.healthInsuranceType}`
        );
        let coverage = getState().interview.coverage;
        coverage.coverageConfirmed = false;
        coverage.provideManualCoverage = false;
        return Promise.resolve(criteria);
    });

// the one below deletes the personCoverage straight from the server. It may not be correct
// export const deleteManuallyProvidedCoverage = (personId, healthInsuranceType = "Insurance") =>
//     createAction(`DELETE_MANUAL_PERSON_COVERAGE`, () =>
//         Axios.delete(`/api/person/external/${personId}/coverage/manual/${healthInsuranceType}`)
//     );

export const getCoverage = encounterId =>
    createAction("GET_COVERAGE", () => Axios.get(`/api/encounter/${encounterId}/coverage`).then(res => res.data));

export const getEncounterHistory = (personId, customerId) =>
    createAction("GET_ENCOUNTER_HISTORY", () =>
        Axios.get(`/api/customer/${customerId}/encounters/person/${personId}`).then(data => data.data)
    );

export const setContinueAfterCoverage = value => createAction("SET_CONTINUE_AFTER_COVERAGE", value);

export const setContinueAfterPiGate = value => createAction("SET_CONTINUE_AFTER_PI_GATE", value);

export const setSimplePersonDemographics = demographics => createAction("SET_PATIENT_DEMOGRAPHICS", demographics);

export const setPatientHasNoId = () =>
    createAction("UPDATE_PATIENT_HAS_NO_ID", (dispatch, getState) => {
        let encounter = getState().interview;
        encounter.entry.patient.doesHaveId = false;
        return Promise.resolve(encounter);
    });

export const getPayerSource = () =>
    createAction("GET_PAYERSOURCE", () => Axios.get("api/payerSource").then(payers => payers));

export const getPersonVerifications = encounterId =>
    createAction("VERIFY_PERSON", (dispatch, getState) => {
        return Axios.get(`/api/encounters/${encounterId}/verification`).then(data => data.data);
    });

export const reVerifyPerson = dataToReVerify => {
    return createAction("VERIFY_PERSON", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        return Axios.put(`/api/encounters/${encounterId}/verification`, dataToReVerify).then(data => {
            dispatch({
                type: "UPDATE_ENTRY_COMPLETE",
                value: data.data.entryModel,
            });

            return data.data.verificationResults;
        });
    });
};
export const getPersonVerificationsCount = encounterId =>
    createAction("VERIFY_PERSON_COUNT", (dispatch, getState) => {
        return Axios.get(`/api/encounters/${encounterId}/verificationCount`).then(data => data.data);
    });

export const setManuallyVerified = dataToReVerify => {
    return createAction("VERIFY_PERSON", (dispatch, getState) => {
        const encounterId = getState().interview.encounterId;
        return Axios.put(`/api/encounters/${encounterId}/verification/manual`, dataToReVerify).then(data => {
            dispatch({
                type: "VERIFY_PERSON",
                value: dataToReVerify,
            });
            return data.data;
        });
    });
};

export const setLongTermCareDetails = ltcData => {
    return createAction("CREATE_LONG_TERM_CARE_DETAILS", (dispatch, getState) => {
        const dataToSave = cloneDeep(ltcData);
        const assets = dataToSave.assetsDetails;
        delete dataToSave.assetsDetails;

        const encounterId = getState().interview.encounterId;
        return dispatch(setAssets(assets)).then(() => {
            return Axios.put(`/api/encounter/${encounterId}/patient/longTermCare`, dataToSave).then(data => {
                return dataToSave;
            });
        });
    });
};

export const cancelCoverageDiscovery = () => {
    return createAction("CANCEL_COVERAGE_DISCOVERY");
};
